import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the pathname changes.
 * Mounts once inside <BrowserRouter> so it applies to every route.
 * Anchor scroll (URLs with a hash like `/pricing#overage`) is left alone
 * so in-page anchors keep working.
 */
export default function ScrollToTopOnRouteChange() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return; // let the browser resolve #anchor
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname, hash]);
    return null;
}
